import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedItemComponent {
  mostrarViatico = false
  colores = {
    '1': '#b4045f',
    '2': '#01a9db',
  }
  data
  eliminando = false
  misViaticos
  autorizar
  onChange
  status = {
    '1': 'Anticipo',
    '2': 'Reembolso',
  }

  constructor ($state) {
    this.$state = $state
  }

  $onInit () {
    this.tipoViatico = (this.data.tipo_id === 2 ? 'Comprobación' : 'Anticipo')
    this.totalizar()
  }

  actualizar (key, data) {
    if (!key || !data) return

    this.data.solicitudes[key] = data
    this.totalizar()
  }

  goToViatico () {
    this.$state.go('viaticos.viaticos.viatico', {viatico_id: this.data.informacion.viatico_id})
  }

  eliminar (data) {
    if (!data.eliminado) {
      this.eliminando = false
      return
    }

    this.verViatico()
    this.onChange({$event: {detail: data}})
  }

  totalizar () {
    this.data.informacion.eliminable = Object.keys(this.data.solicitudes).every((tipoSolicitud) => (this.data.solicitudes[tipoSolicitud].length ? this.data.solicitudes[tipoSolicitud].every((solicitud) => solicitud.eliminable) : true))
    this.data.resumen.anticipos = this.data.solicitudes.anticipos.reduce((total, item) => total + (item.autorizado && item.pagado ? item.total : 0), 0)
    this.data.resumen.comprobaciones = this.data.solicitudes.comprobaciones.reduce((total, item) => total + (item.autorizado ? item.total : 0), 0)
    this.data.resumen.devoluciones = this.data.solicitudes.devoluciones.reduce((total, item) => total + (item.autorizado ? item.total : 0), 0)
    this.data.resumen.reembolsos = this.data.solicitudes.reembolsos.reduce((total, item) => total + (item.autorizado && item.pagado ? item.total : 0), 0)
    this.data.resumen.saldo = (this.data.resumen.comprobaciones + this.data.resumen.devoluciones) - (this.data.resumen.anticipos + this.data.resumen.reembolsos)
  }

  verViatico () {
    this.mostrarViatico = !this.mostrarViatico
  }

  expandir () {
    this.data.expandido = !this.data.expandido
  }
}

module.component('viaticosSharedItem', {
  controller: ViaticosSharedItemComponent,
  template,
  bindings: {
    data: '<',
    misViaticos: '<',
    autorizar: '<',
    pendientesAutorizar: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/item/component.js